import type { ArquivosAplicativoModel } from "../models/arquivosAplicativoModel"

export enum ArquivosAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_URL = "ATUALIZAR_URL",
}

export type ArquivosAplicativoActionModel =
    | {
          type: ArquivosAplicativoActionsTypes.CARREGAR
          payload: ArquivosAplicativoModel
      }
    | {
          type: ArquivosAplicativoActionsTypes.ATUALIZAR_URL
          payload: {
              campo: keyof Omit<ArquivosAplicativoModel, "podeEditar" | "ehClienteFiel">
              url: string | null
          }
      }
